import * as React from "react"

type Props = {
  children: React.ReactNode
  clamp: string
}

const TextRowClamp: React.FC<Props> = ({ children, clamp }) => (
  <div className="text-row-clamp" style={{ WebkitLineClamp: clamp }}>
    {children}
  </div>
)

export default TextRowClamp
